module.exports = __webpack_public_path__ + "245b01148dc6f94f7283ddf9aabc708d.svg";